/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../../common/countries';
import '../feeplans_model';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "feeplans": {
        "nested": {
          "events": {
            "nested": {
              "RequestedCaptureFee": {
                "fields": {
                  "totalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "country": {
                    "type": ".squareup.common.countries.Country",
                    "id": 3,
                    "rule": "optional"
                  },
                  "feeplanProduct": {
                    "type": ".squareup.feeplans.model.FeePlanProduct",
                    "id": 4,
                    "rule": "optional"
                  },
                  "paymentToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "orderId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "externalId": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "applyAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feeplans?.nested?.events?.nested?.RequestedCaptureFee) {
  $root.addJSON(jsonData);
}

/**
 * Message used to request fee assessment for capture related transactions
 *
 * SOURCE RequestedCaptureFee @ squareup/feeplans/events/requested_fee_events.proto at 16:1
 */
export const RequestedCaptureFee = $root.lookupType('squareup.feeplans.events.RequestedCaptureFee');
fixType(RequestedCaptureFee, {
  totalAmount: {
    required: true
  },
  unitToken: {
    required: true
  },
  country: {
    required: true
  },
  feeplanProduct: {
    required: true
  },
  externalId: {
    required: true
  }
});
Builder.createAndAttachToType(RequestedCaptureFee);